export const CONVERSATION_QUERY_KEY = "conversation";
